import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import { Icon } from '@iconify/react';
import { useTranslations } from '../../../../hooks/use-translations';

/**
 * Confirmation dialog shown when saving changes to fields that are normally synced from Skillko.
 * Offers the user a soft warning with the option to still save, or to instead go update the data
 * in Skillko / refresh the latest Skillko data (discarding the local edit).
 */
const SkillkoEditConfirmDialog = ({
  open,
  changedFieldLabels = [],
  skillkoUrl,
  refreshLoading = false,
  onCancel,
  onOpenSkillko,
  onRefresh,
  onConfirm,
}) => {
  const { t } = useTranslations();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t('profiles.form.skillkoEditConfirmTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('profiles.form.skillkoEditConfirmBody', { fields: changedFieldLabels.join(', ') })}
        </DialogContentText>
        <DialogContentText sx={{ mt: 1.5 }}>
          {t('profiles.form.skillkoEditConfirmHint')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexWrap: 'wrap', gap: 1, justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} color="inherit">
          {t('common.cancel')}
        </Button>
        {skillkoUrl && (
          <Button
            onClick={onOpenSkillko}
            variant="outlined"
            startIcon={<Icon icon="mdi:open-in-new" width="18" height="18" />}
          >
            {t('profiles.actionsMenu.openInSkillko')}
          </Button>
        )}
        <LoadingButton
          onClick={onRefresh}
          variant="outlined"
          loading={refreshLoading}
          disabled={refreshLoading}
          startIcon={!refreshLoading ? <Icon icon="mdi:cloud-sync" width="18" height="18" /> : null}
        >
          {t('profiles.form.refreshFromSkillko')}
        </LoadingButton>
        <Button onClick={onConfirm} color="warning" variant="contained">
          {t('profiles.form.skillkoEditSaveAnyway')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SkillkoEditConfirmDialog;
